// Default site content — also seeded on backend startup.
// Each editable phrase/image lives here so admin can override it via /admin/content.

export const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/ff078f22-bc2b-467a-b845-6483b385dad8/images/302c26b27731fd0e1bb2234e1bd62df38461c98c82a5d2911757fd37610a50c6.png";
export const COCKTAIL_IMG = "https://static.prod-images.emergentagent.com/jobs/ff078f22-bc2b-467a-b845-6483b385dad8/images/351155b8bd4f64ce30cde2295c1cb3f9b8b7cbfff2e48c4fbb454b22cc7d4944.png";
export const TABLE_IMG = "https://images.unsplash.com/photo-1767050292710-8e5da59ec5d8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwZmluZSUyMGRpbmluZyUyMGV2ZW50fGVufDB8fHx8MTc3ODY2MzMwMnww&ixlib=rb-4.1.0&q=85";
export const PLATE_IMG = "https://images.unsplash.com/photo-1765100022784-5e72b418d34b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHxhZnJpY2FuJTIwY3Vpc2luZSUyMGdvdXJtZXR8ZW58MHx8fHwxNzc4NjYzMzAyfDA&ixlib=rb-4.1.0&q=85";
export const RECEPTION_IMG = "https://images.unsplash.com/photo-1769812343462-84c46af1e156?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxlbGVnYW50JTIwZmluZSUyMGRpbmluZyUyMGV2ZW50fGVufDB8fHx8MTc3ODY2MzMwMnww&ixlib=rb-4.1.0&q=85";

export const DEFAULT_CONTENT = {
    brand: {
        script_pink: "Éveillez les papilles.",
        script_gold: "Marquez les esprits.",
        footer_tagline: "Gastronomie sénégalaise raffinée, pour des événements inoubliables.",
        established: "Saveurs · Depuis 2018",
        established_brand: "Kayama",
    },
    contact: {
        phone: "07 66 72 95 29",
        phone_href: "+33766729529",
        email: "contact@kayamasaveurs.com",
        instagram_handle: "@kayamasaveurs81",
        instagram_url: "https://instagram.com/kayamasaveurs81",
        website_label: "www.kayamasaveurs.com",
        website_url: "https://www.kayamasaveurs.com",
        zone: "France · Sénégal · Sur demande",
    },
    accueil: {
        hero: {
            overline: "Traiteur Événementiel",
            h1_part1: "Gastronomie",
            h1_italic: "sénégalaise",
            h1_part3: "raffinée.",
            script: "Éveillez les papilles.",
            subtitle: "De la cérémonie intime aux grandes réceptions, nous composons des tables d'exception où chaque saveur raconte une histoire.",
            image: HERO_IMG,
            cta_primary: "Demander un devis",
            cta_secondary: "Découvrir les menus",
            badge_title: "Kayama",
            badge_subtitle: "Saveurs · Depuis 2018",
        },
        intro: {
            overline: "Notre signature",
            title_part1: "Une cuisine d'auteur,",
            title_part2: "entre",
            italic: "terroir et émotion",
            title_part3: ".",
            text: "Inspirée des héritages sénégalais et sublimée par une approche contemporaine, Kayama Saveurs imagine pour chaque événement une partition unique — produits frais, dressage soigné, service attentionné.",
        },
        services_preview: [
            { title: "Événements privés & professionnels", text: "Mariages, anniversaires, séminaires, réceptions… une mise en scène à la hauteur de votre événement.", image: TABLE_IMG, icon: "users" },
            { title: "Cuisine authentique & produits frais", text: "Des saveurs uniques préparées avec passion par notre équipe de chefs.", image: PLATE_IMG, icon: "chef" },
            { title: "Prestation sur mesure", text: "Service, dressage, décoration, livraison — chaque détail pensé pour votre confort.", image: COCKTAIL_IMG, icon: "sparkles" },
        ],
        philosophy: {
            overline: "L'art de recevoir",
            title_part1: "Faites de votre événement",
            italic: "un moment inoubliable.",
            text: "Chez Kayama Saveurs, nous croyons qu'un repas réussi est une œuvre collective : l'élégance d'un dressage, la justesse des saveurs, le sourire d'un service attentionné. Nous mettons notre savoir-faire au service de votre histoire.",
            image: PLATE_IMG,
            stats: [],
        },
        cta_banner: {
            script: "Marquez les esprits.",
            title: "Imaginons ensemble votre prochain événement.",
            image: COCKTAIL_IMG,
            cta: "Demander un devis",
        },
    },
    apropos: {
        hero: {
            overline: "À propos",
            h1_part1: "L'âme d'une",
            h1_italic: "cuisine",
            h1_part2: "qui rassemble.",
        },
        image: HERO_IMG,
        script_under_image: "Marquez les esprits.",
        paragraphs: [
            "Kayama Saveurs est née d'une conviction simple : la cuisine sénégalaise mérite d'être célébrée avec l'élégance qu'elle inspire. Nos plats puisent leur force dans les marchés colorés de Dakar, dans les recettes transmises de mère en fille, dans la chaleur d'un partage autour de la table.",
            "Aujourd'hui, nous prolongeons cette tradition au cœur de vos événements — mariages, séminaires, baptêmes, dîners d'entreprise — en composant des cartes sur mesure qui honorent vos invités et votre histoire.",
            "Notre équipe — chefs, maîtres d'hôtel, décorateurs — partage une exigence commune : faire de chaque moment un souvenir précieux. Du choix des produits frais à la finition d'un dressage, chaque détail est pensé pour vous offrir une expérience pleine de sens.",
        ],
        promise_label: "Notre promesse",
        promise_value: "Authenticité & raffinement",
        signature_label: "Notre signature",
        signature_value: "Le goût du partage",
        banner: {
            image: RECEPTION_IMG,
            script: "Éveillez les papilles.",
            text: "Chaque assiette, une déclaration d'amour à nos terres.",
        },
    },
    services: {
        hero: {
            overline: "Nos prestations",
            h1_part1: "Une cuisine à",
            h1_italic: "votre image",
            h1_part2: ".",
            subtitle: "Trois univers, une même exigence : sublimer chaque moment de votre événement.",
        },
        items: [
            {
                icon: "heart",
                title: "Mariages & cérémonies",
                sub: "Le grand jour mérite une cuisine d'exception",
                text: "Cocktails de bienvenue, dîner gastronomique, pièce montée — nous orchestrons chaque temps fort de votre union avec une attention millimétrée.",
                bullets: ["Cocktail dînatoire & buffet", "Service à l'assiette", "Décor & dressage floral", "Coordination jour J"],
                image: TABLE_IMG,
            },
            {
                icon: "briefcase",
                title: "Séminaires & entreprise",
                sub: "Restaurer, surprendre, fidéliser",
                text: "Petits-déjeuners d'affaires, déjeuners, cocktails de lancement, gala annuel — des prestations efficaces et raffinées qui impressionnent vos invités.",
                bullets: ["Plateaux-repas premium", "Pauses gourmandes", "Cocktails de networking", "Logistique clé-en-main"],
                image: COCKTAIL_IMG,
            },
            {
                icon: "cake",
                title: "Anniversaires & fêtes familiales",
                sub: "Célébrer ce qui compte",
                text: "Baptêmes, anniversaires, baby showers, retrouvailles… des menus chaleureux à partager autour d'une table conviviale ou d'un buffet généreux.",
                bullets: ["Menus personnalisés", "Spécialités sénégalaises", "Pâtisseries maison", "Animations culinaires"],
                image: PLATE_IMG,
            },
        ],
        extras_overline: "Prestations sur mesure",
        extras_title: "Et tellement plus encore.",
        extras: [
            { icon: "wine", t: "Bar & mixologie", d: "Cocktails sénégalais signature, bissap, gingembre frais, jus pressés." },
            { icon: "sparkles", t: "Décoration & dressage", d: "Vaisselle, nappage, fleurs, mise en scène : nous habillons votre événement." },
            { icon: "truck", t: "Livraison & service", d: "Équipe de service en uniforme, livraison sur site, installation et clean-up." },
        ],
    },
    galerie: {
        hero: {
            overline: "Galerie",
            h1_part1: "Un regard sur",
            h1_italic: "nos créations",
            h1_part2: ".",
            subtitle: "Quelques instants choisis parmi nos derniers événements — buffets gourmands, dressages soignés, ambiances raffinées.",
        },
        images: [
            { url: HERO_IMG, alt: "Plat signature sénégalais", h: "tall" },
            { url: TABLE_IMG, alt: "Table dressée gold", h: "short" },
            { url: "https://images.unsplash.com/photo-1777312378555-f19dbcb49d53?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Buffet desserts", h: "short" },
            { url: COCKTAIL_IMG, alt: "Cocktail dînatoire", h: "tall" },
            { url: RECEPTION_IMG, alt: "Réception élégante", h: "short" },
            { url: PLATE_IMG, alt: "Plat gourmet", h: "tall" },
            { url: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Verres en cristal", h: "short" },
            { url: "https://images.unsplash.com/photo-1555244162-803834f70033?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Cocktail coloré", h: "short" },
            { url: "https://images.unsplash.com/photo-1559339352-11d035aa65de?crop=entropy&cs=srgb&fm=jpg&q=85", alt: "Plat raffiné", h: "tall" },
        ],
    },
    menus: {
        hero: {
            overline: "Menus & formules",
            h1_part1: "Des cartes pensées pour",
            h1_italic: "l'émotion",
            h1_part2: ".",
            subtitle: "Trois formules-phares à composer librement avec notre équipe pour des menus 100% sur mesure.",
        },
        formulas: [
            {
                name: "Cocktail dînatoire",
                baseline: "Pour réceptions debout, vins d'honneur et lancements",
                price: "À partir de 35€ / pers.",
                sections: [
                    { title: "Mises en bouche", items: [
                        { name: "Accras de morue", desc: "Sauce mangue épicée" },
                        { name: "Brochettes de poulet yassa", desc: "Citron confit, oignons fondants" },
                        { name: "Pastels", desc: "Aux crevettes ou au bœuf, sauce kaani" },
                        { name: "Mini blinis", desc: "Tartare de thiof à la mangue" },
                    ]},
                    { title: "Pièces gourmandes", items: [
                        { name: "Verrines de thiébou djeun", desc: "Riz parfumé, poisson, légumes confits" },
                        { name: "Cuillère de mafé", desc: "Bœuf mijoté, sauce d'arachide" },
                        { name: "Plateau de fromages affinés", desc: "Sélection française & accompagnements" },
                    ]},
                    { title: "Douceurs", items: [
                        { name: "Thiakry crémeux", desc: "Yaourt, mil, vanille bourbon" },
                        { name: "Mini fondants", desc: "Au baobab et fruits de la passion" },
                        { name: "Salade de fruits", desc: "Mangue, ananas, gingembre frais" },
                    ]},
                ],
            },
            {
                name: "Buffet généreux",
                baseline: "Pour mariages, baptêmes et grands rassemblements",
                price: "À partir de 55€ / pers.",
                sections: [
                    { title: "Entrées", items: [
                        { name: "Salade niébé", desc: "Haricots cornille, oignons rouges, citron vert" },
                        { name: "Avocat sauce rose", desc: "Avocat mûr, crevettes roses, mayonnaise maison" },
                        { name: "Soupe kandia", desc: "Gombos, poisson, riz parfumé" },
                    ]},
                    { title: "Plats chauds", items: [
                        { name: "Thiébou djeun rouge", desc: "Le plat national, façon Kayama" },
                        { name: "Yassa au poulet fermier", desc: "Oignons fondants, riz basmati" },
                        { name: "Mafé d'agneau", desc: "Sauce d'arachide onctueuse, légumes racines" },
                        { name: "Poisson grillé entier", desc: "Sauce kaani & attiéké" },
                    ]},
                    { title: "Desserts", items: [
                        { name: "Pièce montée florale", desc: "Personnalisable aux couleurs de l'événement" },
                        { name: "Sombi", desc: "Riz au lait coco et vanille" },
                        { name: "Corbeille de fruits exotiques", desc: "Mangue, ananas, papaye, coco fraîche" },
                    ]},
                ],
            },
            {
                name: "Service à l'assiette",
                baseline: "Pour dîners d'exception, gala et événements VIP",
                price: "À partir de 85€ / pers.",
                sections: [
                    { title: "Amuse-bouche", items: [
                        { name: "Bouchée de baobab", desc: "Mousseline de tubercule, écume de gingembre" },
                    ]},
                    { title: "Entrée", items: [
                        { name: "Tartare de thiof", desc: "Mangue, coriandre, huile de bissap" },
                    ]},
                    { title: "Plat", items: [
                        { name: "Filet de bœuf façon mafé", desc: "Sauce d'arachide aérienne, légumes glacés" },
                        { name: "Option mer", desc: "Pavé de capitaine, sauce yassa allégée, riz noir" },
                    ]},
                    { title: "Dessert signature", items: [
                        { name: "Sphère bissap-coco", desc: "Cœur fruits de la passion, biscuit mil" },
                    ]},
                ],
            },
        ],
        bottom_script: "Envie d'un menu sur mesure ?",
        bottom_cta: "Composer mon menu",
    },
    daily_menus: {
        enabled: true,
        overline: "Menus du jour",
        title_part1: "Ce que l'on cuisine",
        italic: "aujourd'hui",
        title_part2: ".",
        subtitle: "Découvrez les plats préparés du jour par notre brigade — disponibles en livraison et sur place.",
        items: [
            {
                date: "Aujourd'hui",
                name: "Thiébou djeun rouge",
                desc: "Riz parfumé, poisson capitaine, légumes confits, sauce tomate épicée.",
                price: "12 €",
                image: "https://images.unsplash.com/photo-1765100022784-5e72b418d34b?crop=entropy&cs=srgb&fm=jpg&q=85",
            },
            {
                date: "Aujourd'hui",
                name: "Yassa poulet",
                desc: "Poulet fermier mariné au citron confit, oignons fondants, riz basmati.",
                price: "11 €",
                image: "https://static.prod-images.emergentagent.com/jobs/ff078f22-bc2b-467a-b845-6483b385dad8/images/302c26b27731fd0e1bb2234e1bd62df38461c98c82a5d2911757fd37610a50c6.png",
            },
            {
                date: "Demain",
                name: "Mafé d'agneau",
                desc: "Agneau mijoté longuement dans une sauce d'arachide, légumes racines.",
                price: "13 €",
                image: "https://static.prod-images.emergentagent.com/jobs/ff078f22-bc2b-467a-b845-6483b385dad8/images/351155b8bd4f64ce30cde2295c1cb3f9b8b7cbfff2e48c4fbb454b22cc7d4944.png",
            },
        ],
    },
    contact_page: {
        hero: {
            overline: "Contact & devis",
            h1_part1: "Imaginons votre",
            h1_italic: "événement",
            h1_part2: ".",
            subtitle: "Décrivez-nous votre projet — nous vous répondons sous 24 h avec une proposition sur mesure.",
        },
        coords_overline: "Nos coordonnées",
        coords_title: "Parlons-en.",
        coords_script: "À très vite.",
        form_overline: "Formulaire de devis",
        form_title: "Demandez votre devis sur mesure.",
        success_title: "Merci !",
        success_script: "À très vite.",
        success_text: "Votre demande nous est bien parvenue. Notre équipe revient vers vous sous 24 heures avec une proposition personnalisée.",
    },
};
